import { Link } from '@radix-ui/react-navigation-menu'
import React from 'react'

import { styled } from '~/styled'
import { preventEvent } from '~/utilities/event/preventEvent'
import { getExternalAnchorProps } from '~/utilities/uri'

import { navigationMenuVerticalItemStyles } from './NavigationMenuVertical.styles'
import { NavigationMenuVerticalItem } from './NavigationMenuVerticalItem'
import { NavigationMenuVerticalItemContent } from './NavigationMenuVerticalItemContent'

const StyledNavigationMenuVerticalLink = styled(Link, {
  base: navigationMenuVerticalItemStyles,
  variants: {
    size: {
      md: ['min-h-10'],
      lg: ['min-h-12']
    }
  }
})

type NavigationMenuVerticalItemProps = React.ComponentProps<
  typeof StyledNavigationMenuVerticalLink
>

export const NavigationMenuVerticalLink = ({
  as,
  href,
  children,
  ...rest
}: NavigationMenuVerticalItemProps) => {
  const Component = (as || (href ? 'a' : 'button')) as React.ElementType
  const componentProps = as
    ? {}
    : href
      ? getExternalAnchorProps(href)
      : { type: 'button' }

  return (
    <NavigationMenuVerticalItem>
      <StyledNavigationMenuVerticalLink
        size="lg"
        href={href}
        {...rest}
        {...componentProps}
        onSelect={preventEvent}
        asChild // ?: Can't use `as` for this as we lose `data-active` etc. attributes when we try to. Using `asChild` and `Component` as a workaround.
      >
        <Component>
          <NavigationMenuVerticalItemContent>
            {children}
          </NavigationMenuVerticalItemContent>
        </Component>
      </StyledNavigationMenuVerticalLink>
    </NavigationMenuVerticalItem>
  )
}
